import apiClient from './api';

export interface OrgBranding {
  introUrl?: string;
  outroUrl?: string;
}

export const brandingApi = {
  get: async (): Promise<{ success: boolean; branding: OrgBranding }> => {
    const response = await apiClient.get('/branding');
    return response.data;
  },

  uploadIntro: async (file: File): Promise<{ success: boolean; introUrl?: string; message?: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/branding/intro', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
  },

  uploadOutro: async (file: File): Promise<{ success: boolean; outroUrl?: string; message?: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post('/branding/outro', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    return response.data;
  },

  removeIntro: async (): Promise<{ success: boolean; message?: string }> => {
    const response = await apiClient.delete('/branding/intro');
    return response.data;
  },

  removeOutro: async (): Promise<{ success: boolean; message?: string }> => {
    const response = await apiClient.delete('/branding/outro');
    return response.data;
  },
};

export default brandingApi;
